<script>
	import { onMount } from 'svelte';
	import { push } from 'svelte-spa-router';
	import fetchData from '../api.js';
	import UserStore from '../stores/user';
	import { clearActiveCart } from '../stores/activeCart';
	import AppShell from '../components/AppShell.svelte';
	import Icon from '../components/Icon.svelte';

	let current = '';
	let next = '';
	let again = '';
	let busy = false;
	let error = '';
	let done = false;

	async function changePassword() {
		error = '';
		done = false;
		if (next.length < 8) return (error = 'הסיסמה החדשה צריכה להיות לפחות 8 תווים');
		if (next !== again) return (error = 'שתי הסיסמאות החדשות לא זהות');
		busy = true;
		const res = await fetchData({ action: 'agents_change_password', token: $UserStore.data, current_password: current, new_password: next });
		busy = false;
		if (res && Number(res.success) === 1) {
			const user = { ...$UserStore, must_change_password: false };
			localStorage.setItem('user', JSON.stringify(user));
			UserStore.set(user);
			current = next = again = '';
			done = true;
		} else {
			error = (res && res.msg) || 'לא הצלחנו לשנות סיסמה. נסה שוב.';
		}
	}

	async function logout() {
		await fetchData({ action: 'agents_logout', token: $UserStore.data });
		clearActiveCart();
		localStorage.setItem('user', '{}');
		UserStore.set({});
		push('/login');
	}

	onMount(() => {
		if (!$UserStore || !$UserStore.data) push('/login');
	});
</script>

<AppShell title="החשבון שלי">
	<div class="cols">
		<div>
			<div class="card who-card">
				<div class="avatar">{($UserStore.agent_name || '?').trim().charAt(0)}</div>
				<div class="who">
					<b>{$UserStore.agent_name || ''}</b>
					<span class="muted" dir="ltr">{$UserStore.email || ''}</span>
					<span class="badge-dark role">{$UserStore.role === 'admin' ? 'מנהל' : 'סוכן'}</span>
				</div>
			</div>

			{#if $UserStore.role === 'admin'}
				<button class="card row-btn" on:click={() => push('/admin/users')}>
					<Icon name="user" /> <span>ניהול משתמשים</span><small class="muted">הוספת סוכנים, סיסמאות, חסימה</small>
				</button>
			{/if}

			<button class="card row-btn danger" on:click={logout}><Icon name="logout" /> <span>התנתקות</span></button>
		</div>

		<form class="card pw" on:submit|preventDefault={changePassword}>
			<h2>החלפת סיסמה</h2>
			{#if $UserStore.must_change_password}
				<div class="alert-error">יש לבחור סיסמה חדשה משלך לפני שממשיכים.</div>
			{/if}
			<label><span>סיסמה נוכחית</span><input type="password" bind:value={current} autocomplete="current-password" dir="ltr" required /></label>
			<label><span>סיסמה חדשה (לפחות 8 תווים)</span><input type="password" bind:value={next} autocomplete="new-password" dir="ltr" required /></label>
			<label><span>שוב את הסיסמה החדשה</span><input type="password" bind:value={again} autocomplete="new-password" dir="ltr" required /></label>
			{#if error}<div class="alert-error">{error}</div>{/if}
			{#if done}<div class="alert-ok">הסיסמה הוחלפה.</div>{/if}
			<button class="btn-primary" type="submit" disabled={busy}>{busy ? 'שומר…' : 'שמירת סיסמה'}</button>
		</form>
	</div>
</AppShell>

<style>
	.cols { display: grid; grid-template-columns: 1fr 1fr; gap: 18px; align-items: start; max-width: 1000px; }
	.card { background: var(--surface); border: 1px solid var(--line); border-radius: var(--radius); padding: 20px; margin-bottom: 14px; }
	.who-card { display: flex; align-items: center; gap: 16px; }
	.avatar { width: 64px; height: 64px; border-radius: 50%; background: var(--ink); color: #fff; display: grid; place-items: center; font-weight: 800; font-size: 26px; flex: none; }
	.who { display: flex; flex-direction: column; align-items: flex-start; gap: 2px; }
	.who b { font-size: 22px; }
	.role { margin-top: 6px; }
	.row-btn { display: flex; align-items: center; gap: 12px; width: 100%; min-height: 64px; font-size: 18px; text-align: start; flex-wrap: wrap; }
	.row-btn small { flex-basis: 100%; padding-inline-start: 36px; font-size: 14px; margin-top: -6px; }
	.row-btn.danger { color: var(--danger); }
	.pw { display: flex; flex-direction: column; gap: 14px; }
	.pw h2 { margin: 0; font-size: 21px; }
	label { display: flex; flex-direction: column; gap: 6px; }
	label span { font-size: 15px; color: var(--ink-2); }
	input { height: 52px; border: 1px solid var(--line-strong); border-radius: 12px; padding: 0 14px; font-size: 18px; text-align: left; }
	input:focus { outline: none; border-color: var(--ink); box-shadow: inset 0 0 0 1px var(--ink); }
	@media (max-width: 1000px) {
		.cols { grid-template-columns: 1fr; }
	}
</style>
